import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";

import moment from "moment";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Manufactureds_Forms_Object} state
 *  @property {object} model
 *  @property {Manufactureds_Forms_Properties} model.properties
 *  @property {Manufactureds_Forms_Is} model.is
 *  @property {Manufactureds_Forms_Has} model.has
 */
export default class FederalExciseTaxFormObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Manufactureds_Forms._name);

		this.state.year = moment().format('Y');
		this.state.form = 13;
	}

	form = () => {
		/** @type {Manufactureds_Forms_Properties} properties */
		let properties = this.model.properties;
		/** @type {Manufactureds_Forms_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>

							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>

							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Type</span>
									</div>
									<div className="col-8">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											objects={[
												{pkey: 'quarterly', name: 'Quarterly'},
												{pkey: 'annual', name: 'Annual'},
											]}
											property={properties.type}
											value={object.type}
											error={object.type_error}
											text={'name'}
											nullable={false}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<span className="input-label">Amended</span>
									</div>
									<div className="col-6 text-right">
										<Framework.Elements.ButtonSwitch
											property={properties.amended}
											value={object.amended}
											error={object.amended_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Yes'}
											labelFalse={'No'}
										/>

									</div>
								</div>
							</div>
							<div className="form-group">
								<div className="row">
									<div className="col">
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Year"}
												value={object.year}
												error={object.year_error}
												property={properties.year}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									{object.type === 'quarterly' &&
									<div className="col-6">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											objects={[
												{pkey: 1, name: 'Jan 1 - Mar 31'},
												{pkey: 2, name: 'Apr 1 - Jun 30'},
												{pkey: 3, name: 'July 1 - Sept 30'},
												{pkey: 4, name: 'Oct 1 - Dec 31'},
											]}
											property={properties.quarter}
											value={object.quarter}
											error={object.quarter_error}
											text={'name'}
											nullable={false}
										/>
									</div>}
								</div>
							</div>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Payment</span>
									</div>
									<div className="col-8">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											objects={[
												{pkey: 'Check', name: 'Check'},
												{pkey: 'EFT', name: 'EFT'},
												{pkey: 'Money Order', name: 'Money Order'},
												{pkey: 'Other', name: 'Other'},
											]}
											property={properties.payment}
											value={object.payment}
											error={object.payment_error}
											text={'name'}
											nullable={false}
										/>
									</div>
								</div>
							</div>

						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
